//车辆电子围栏
export default [{
  path: 'vehicleElectronicFence',
  name: 'vehicleElectronicFence',
  component: function component() {
    return import('@/views/electronicFenceManage');
  }
}, {
  path: 'vehicleElectronicFenceAdd',
  name: 'vehicleElectronicFenceAdd',
  component: function component() {
    return import('@/views/electronicFenceManage/add.vue');
  }
}, {
  path: 'vehicleElectronicFenceList',
  name: 'vehicleElectronicFenceList',
  component: function component() {
    return import('@/views/electronicFenceManage/list.vue');
  }
}, {
  path: 'vehicleElectronicFenceDetail',
  name: 'vehicleElectronicFenceDetail',
  component: function component() {
    return import('@/views/electronicFenceManage/detail.vue');
  }
}];